// FIXME: Due to a circular dependency issues, we cannot use `~utils` import
import { translate } from "utils/string-table";

export const computeInitialSelected = (validList: string[], initialSelection: string[]) => {
  const isValid = initialSelection.every((item) => validList.includes(item));
  return isValid ? initialSelection : [translate("UNKNOWN")];
};

export const computeInitialLanguageSelected = (validList: string[], initialSelection: string[]) => {
  const result: string[] = [];
  let hasCustomLanguage = false;

  for (const item of initialSelection) {
    if (validList.includes(item)) {
      result.push(item);
    } else if (validList.includes("Other")) {
      hasCustomLanguage = true;
    } else {
      return [translate("UNKNOWN")];
    }
  }

  if (hasCustomLanguage && !result.includes("Other")) {
    result.push("Other");
  }

  return result;
};
